import { appState, dispatchStateEvent } from '../../store/appState.js';
import { fetchTransactions, deleteTransactionAndRefund } from '../../api/transactions.js';
import { showToast } from '../../utils/toast.js';
import { applyFilters, updateFilterBadge } from '../modals/filterModal.js';

let renderedMonthsCount = 1;

// 8. QUẢN LÝ TAB TRANSACTIONS (Gom nhóm theo Tháng & Gập/Mở)
export async function renderTransactionsTab(resetPagination = false) {
    if (resetPagination) renderedMonthsCount = 1;

    const txnsList = document.getElementById('txns-list');
    const btnShowMore = document.getElementById('btn-txns-show-more');
    if(!txnsList) return;
    
    if (resetPagination) {
        txnsList.innerHTML = '<p class="text-center text-gray-500 mt-4"><i class="fa-solid fa-spinner fa-spin"></i> Loading transactions...</p>';
    }

    let txns = appState.currentTransactionsList;
    if (resetPagination || !txns || txns.length === 0) {
        txns = await fetchTransactions();
        appState.currentTransactionsList = txns;
    }
    
    // Apply filters (nếu có)
    const filteredTxns = applyFilters(txns);
    updateFilterBadge();

    txnsList.innerHTML = '';

    if (!filteredTxns || filteredTxns.length === 0) {
        const f = appState.filterState;
        const hasFilter = f.keyword || f.type !== 'all' || f.walletId || f.useDateRange || f.categoryIds?.length || f.tagIds?.length;
        txnsList.innerHTML = hasFilter
            ? '<p class="text-center text-gray-500 mt-4">No transactions match your filters.</p>'
            : '<p class="text-center text-gray-500 mt-4">No transactions found.</p>';
        if(btnShowMore) {
            btnShowMore.classList.add('hidden');
            btnShowMore.classList.remove('flex');
        }
        return;
    }

    // 1. Thuật toán Gom nhóm (Grouping) theo Tháng/Năm — dùng filteredTxns
    const groupedTxns = {};
    const monthKeys = [];
    const processedTransfers = new Set();

    filteredTxns.forEach(t => {
        if (t.linked_txn_id) {
            if (processedTransfers.has(t.id)) return;
            processedTransfers.add(t.linked_txn_id);
        }

        const dateObj = new Date(t.transaction_date);
        const monthYear = dateObj.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        
        if (!groupedTxns[monthYear]) {
            groupedTxns[monthYear] = { txns: [], totalIncome: 0, totalExpense: 0, id: 'group-' + dateObj.getTime() };
            monthKeys.push(monthYear);
        }
        
        groupedTxns[monthYear].txns.push(t);
        
        if (!t.linked_txn_id) {
            const val = Number(t.base_amount || t.amount);
            if (t.type === 'income') groupedTxns[monthYear].totalIncome += val;
            else if (t.type === 'expense') groupedTxns[monthYear].totalExpense += val;
        }
    });

    // Cắt lấy số lượng tháng cần hiển thị
    const visibleMonths = monthKeys.slice(0, renderedMonthsCount);

    // 2. Render từng Nhóm (Tháng)
    for (const monthYear of visibleMonths) {
        const data = groupedTxns[monthYear];
        const groupDiv = document.createElement('div');
        groupDiv.className = 'mb-6';
        
        // Render Header của Tháng (Có nút bấm để thu gọn/mở rộng)
        const headerHTML = `
            <div class="flex justify-between items-center mb-3 px-1 cursor-pointer" onclick="window.toggleGroup('${data.id}', this)">
                <h4 class="font-bold text-white text-sm bg-gray-800 px-3 py-1 rounded-full">${monthYear}</h4>
                <div class="text-xs font-bold bg-darkbg px-2 py-1 rounded-lg border border-gray-700">
                    <i class="fa-solid fa-chevron-up text-gray-400 transition-transform"></i>
                </div>
            </div>
            <div id="${data.id}" class="space-y-3 transition-all duration-300 transform origin-top"></div>
        `;
        groupDiv.innerHTML = headerHTML;
        txnsList.appendChild(groupDiv);
        
        const bodyDiv = groupDiv.querySelector(`#${data.id}`);

        // 3. Render các thẻ giao dịch bên trong Tháng đó
        data.txns.forEach(t => {
            let htmlCard = '';
            const dateStr = new Date(t.transaction_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

            if (t.linked_txn_id) {
                // UI Transfer
                const twin = appState.currentTransactionsList.find(x => x.id === t.linked_txn_id);
                let fromWallet = 'Unknown', toWallet = 'Unknown';
                let fromAmount = Number(t.amount);
                let fromCur = t.currency || 'VND';
                let toAmount = twin ? Number(twin.amount) : 0;
                let toCur = twin ? (twin.currency || 'VND') : 'VND';

                if (t.type === 'expense') {
                    fromWallet = t.wallets ? t.wallets.name : 'Unknown';
                    toWallet = twin && twin.wallets ? twin.wallets.name : 'Unknown';
                } else {
                    // T is Income, Twin is Expense
                    fromWallet = twin && twin.wallets ? twin.wallets.name : 'Unknown';
                    toWallet = t.wallets ? t.wallets.name : 'Unknown';
                    
                    fromAmount = twin ? Number(twin.amount) : 0;
                    fromCur = twin ? (twin.currency || 'VND') : 'VND';
                    toAmount = Number(t.amount);
                    toCur = t.currency || 'VND';
                }

                let displayAmountStr = `<div class="font-bold text-gray-300 text-[16px]">${fromAmount.toLocaleString('en-US')} <span class="text-xs text-gray-500">${fromCur}</span></div>`;
                if (fromCur !== toCur) {
                    displayAmountStr = `
                        <div class="font-bold text-gray-300 text-[16px] whitespace-nowrap">${fromAmount.toLocaleString('en-US')} <span class="text-xs text-gray-500">${fromCur}</span></div>
                        <div class="text-[14px] text-gray-500 mt-0.5 whitespace-nowrap"><i class="fa-solid fa-arrow-turn-down fa-rotate-270 text-[12px] mr-1"></i>${toAmount.toLocaleString('en-US')} <span class="text-xs">${toCur}</span></div>
                    `;
                }

                htmlCard = `
                    <div class="flex-1">
                        <div class="font-bold text-white text-[16px] leading-tight">Transfer</div>
                        <div class="text-[13px] text-gray-400 mt-1"><i class="fa-solid fa-arrow-right-arrow-left mr-1"></i>${fromWallet} ➔ ${toWallet} • ${dateStr}</div>
                    </div>
                    <div class="ml-3 text-right flex flex-col items-end justify-center">
                        ${displayAmountStr}
                    </div>
                `;
            } else {
                // UI Normal
                const isIncome = t.type === 'income';
                const colorClass = isIncome ? 'text-income' : 'text-expense';
                const amountFormatted = Number(t.amount).toLocaleString('en-US');
                const catName = (t.categories && t.categories.name) ? t.categories.name : (t.category_name || 'Uncategorized');
                const walletName = t.wallets ? t.wallets.name : 'Unknown';
                
                let convertedDisplay = '';
                if (t.currency && t.currency !== 'VND') {
                    convertedDisplay = `<div class="text-xs text-gray-400 font-normal mt-0.5">~ ${Number(t.base_amount || 0).toLocaleString('en-US')} VND</div>`;
                }
    
                htmlCard = `
                    <div class="flex-1">
                        <div class="font-bold text-white text-[16px] leading-tight">${catName}</div>
                        <div class="text-[13px] text-gray-400 mt-1"><i class="fa-solid fa-wallet mr-1"></i>${walletName} • ${dateStr}</div>
                    </div>
                    <div class="text-right ml-3 text-[16px]">
                        <div class="font-bold ${colorClass}">${isIncome ? '+' : '-'}${amountFormatted} <span class="text-xs text-gray-400">${t.currency || 'VND'}</span></div>
                        ${convertedDisplay}
                    </div>
                `;
            }

            const card = document.createElement('div');
            card.className = 'bg-cardbg border border-gray-700 px-3 py-2.5 rounded-xl flex justify-between items-center shadow-sm cursor-pointer active:bg-gray-800 transition';
            card.onclick = () => window.openTxnDetail(t);
            card.innerHTML = htmlCard;
            bodyDiv.appendChild(card);
        });
    }

    // 4. Cập nhật nút Show More
    if (btnShowMore) {
        if (renderedMonthsCount < monthKeys.length) {
            btnShowMore.classList.remove('hidden');
            btnShowMore.classList.add('flex');
            
            const newBtn = btnShowMore.cloneNode(true);
            newBtn.innerHTML = 'Show Previous Month'; // explicitly reset from loaded state
            btnShowMore.parentNode.replaceChild(newBtn, btnShowMore); // Replace logic for pure DOM
            
            newBtn.addEventListener('click', () => {
                newBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin mr-2"></i>Loading...';
                renderedMonthsCount++;
                setTimeout(() => {
                    renderTransactionsTab(false); 
                }, 150);
            });
        } else {
            btnShowMore.classList.add('hidden');
            btnShowMore.classList.remove('flex');
        }
    }
}

// Cần phơi hàm này ra toàn cục (window) vì inline onclick HTML đang gọi toggleGroup
window.toggleGroup = function(groupId, headerElement) {
    const body = document.getElementById(groupId);
    const icon = headerElement.querySelector('.fa-chevron-up, .fa-chevron-down');
    
    if (body.classList.contains('hidden')) {
        body.classList.remove('hidden');
        icon.classList.remove('fa-chevron-down');
        icon.classList.add('fa-chevron-up');
    } else {
        body.classList.add('hidden');
        icon.classList.remove('fa-chevron-up');
        icon.classList.add('fa-chevron-down');
    }
}

let selectedTxnId = null; 

export function initTransactionModals() {
    const detailModal = document.getElementById('txn-detail-modal');
    const detailContent = document.getElementById('txn-detail-content');
    const confirmModal = document.getElementById('confirm-modal');

    if(!detailModal) return;

    // Lắng nghe filter thay đổi → re-render tab
    window.addEventListener('filtersChanged', () => {
        renderTransactionsTab(false); // false = không reset pagination
    });

    window.openTxnDetail = function (txn) {
        selectedTxnId = txn.id; 
        
        if (txn.linked_txn_id) {
            const twin = appState.currentTransactionsList.find(x => x.id === txn.linked_txn_id);
            let fromWallet = 'Unknown', toWallet = 'Unknown';
            let fromAmount = Number(txn.amount);
            let fromCur = txn.currency || 'VND';
            let toAmount = twin ? Number(twin.amount) : 0;
            let toCur = twin ? (twin.currency || 'VND') : 'VND';

            if (txn.type === 'expense') {
                fromWallet = txn.wallets ? txn.wallets.name : 'Unknown';
                toWallet = twin && twin.wallets ? twin.wallets.name : 'Unknown';
            } else {
                fromWallet = twin && twin.wallets ? twin.wallets.name : 'Unknown';
                toWallet = txn.wallets ? txn.wallets.name : 'Unknown';
                fromAmount = twin ? Number(twin.amount) : 0;
                fromCur = twin ? (twin.currency || 'VND') : 'VND';
                toAmount = Number(txn.amount);
                toCur = txn.currency || 'VND';
            }

            let displayDetailAmount = `${fromAmount.toLocaleString('en-US')} <span class="text-xl">${fromCur}</span>`;
            if (fromCur !== toCur) {
                displayDetailAmount = `${fromAmount.toLocaleString('en-US')} <span class="text-xl text-gray-500">${fromCur}</span> <i class="fa-solid fa-arrow-right-long text-xl mx-2 text-gray-600"></i> ${toAmount.toLocaleString('en-US')} <span class="text-xl text-white font-bold">${toCur}</span>`;
            }

            document.getElementById('detail-amount').className = `text-3xl font-bold mb-1 text-white`;
            document.getElementById('detail-amount').innerHTML = displayDetailAmount;
            
            document.getElementById('detail-base-amount').classList.add('hidden');
            document.getElementById('detail-category').innerText = 'Transfer';
            document.getElementById('detail-tag').innerHTML = `<span class="bg-gray-700 text-gray-400 font-bold text-[11px] px-2 py-1 rounded-full"><i class="fa-solid fa-arrow-right-arrow-left"></i> Transfer Process</span>`;
            document.getElementById('detail-wallet').innerText = `${fromWallet} ➔ ${toWallet}`;
            document.getElementById('btn-detail-edit').classList.remove('hidden');
        } else {
            const isIncome = txn.type === 'income';
            const colorClass = isIncome ? 'text-income' : 'text-expense';
            
            document.getElementById('detail-amount').className = `text-4xl font-bold mb-1 ${colorClass}`;
            document.getElementById('detail-amount').innerText = `${isIncome ? '+' : '-'}${Number(txn.amount).toLocaleString('en-US')} ${txn.currency || 'VND'}`;
            
            const baseEl = document.getElementById('detail-base-amount');
            if (txn.currency !== 'VND') {
                baseEl.innerText = `~ ${Number(txn.base_amount || 0).toLocaleString('en-US')} VND`;
                baseEl.classList.remove('hidden');
            } else {
                baseEl.classList.add('hidden');
            }

            const catDisplayName = (txn.categories && txn.categories.name) ? txn.categories.name : (txn.category_name || 'Uncategorized');
            document.getElementById('detail-category').innerText = catDisplayName;
            const tagEl = document.getElementById('detail-tag');
            const tagDisplayName = (txn.tags && txn.tags.name) ? txn.tags.name : txn.tag_name;
            if (tagDisplayName) {
                tagEl.innerHTML = `<span class="bg-gray-700 text-gray-300 text-[11px] px-2 py-1 rounded-full">${tagDisplayName}</span>`;
            } else {
                tagEl.innerHTML = `<span class="text-gray-500 font-normal">None</span>`;
            }
            document.getElementById('detail-wallet').innerText = txn.wallets ? txn.wallets.name : 'Unknown';
            document.getElementById('btn-detail-edit').classList.remove('hidden');
        }

        document.getElementById('detail-date').innerText = new Date(txn.transaction_date).toLocaleDateString('en-US');
        document.getElementById('detail-remark').innerText = txn.remark || 'No remark provided.';

        detailModal.classList.remove('hidden');
        detailModal.classList.add('flex');
        setTimeout(() => {
            detailContent.classList.remove('translate-y-full');
            detailContent.classList.add('translate-y-0');
        }, 10);
    }

    document.getElementById('btn-close-detail').addEventListener('click', () => {
        detailContent.classList.remove('translate-y-0');
        detailContent.classList.add('translate-y-full');
        setTimeout(() => {
            detailModal.classList.add('hidden');
            detailModal.classList.remove('flex');
        }, 300);
    });

    document.getElementById('btn-confirm-cancel').addEventListener('click', () => {
        confirmModal.classList.add('hidden');
        confirmModal.classList.remove('flex');
    });

    document.getElementById('btn-detail-delete').addEventListener('click', () => {
        document.getElementById('btn-close-detail').click();
        setTimeout(() => {
            confirmModal.classList.remove('hidden');
            confirmModal.classList.add('flex');
        }, 300);
    });

    document.getElementById('btn-confirm-ok').addEventListener('click', async () => {
        if (!selectedTxnId) return;
        
        const txnToDelete = appState.currentTransactionsList.find(t => t.id === selectedTxnId);
        if (!txnToDelete) return;

        const btnOk = document.getElementById('btn-confirm-ok');
        btnOk.innerText = "Deleting..."; btnOk.disabled = true;

        const isSuccess = await deleteTransactionAndRefund(txnToDelete);

        if (isSuccess) {
            showToast('Transaction deleted & Wallet refunded!', 'success');
            confirmModal.classList.add('hidden');
            confirmModal.classList.remove('flex');
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            showToast('Failed to delete transaction.', 'error');
        }

        btnOk.innerText = "Yes, Delete"; btnOk.disabled = false;
    });

    document.getElementById('btn-detail-edit').addEventListener('click', () => {
        if (!selectedTxnId) return;
        const txn = appState.currentTransactionsList.find(t => t.id === selectedTxnId);
        if (!txn) return;

        appState.editingTxnId = txn.id;
        document.getElementById('btn-close-detail').click();
        
        // Phát event trigger mở modal
        document.getElementById('btn-fab').click();

        setTimeout(() => {
            if (txn.linked_txn_id) {
                // Editing a Transfer
                document.querySelector(`.type-btn[data-type="transfer"]`).click();
                const twin = appState.currentTransactionsList.find(x => x.id === txn.linked_txn_id);
                let fromTxn, toTxn;
                if (txn.type === 'expense') { fromTxn = txn; toTxn = twin; } 
                else { fromTxn = twin; toTxn = txn; }

                if (fromTxn && fromTxn.wallets) {
                    appState.formState.wallet = { id: fromTxn.wallet_id, name: fromTxn.wallets.name, currency: fromTxn.currency || 'VND' };
                }
                if (toTxn && toTxn.wallets) {
                    appState.formState.walletTo = { id: toTxn.wallet_id, name: toTxn.wallets.name, currency: toTxn.currency || 'VND' };
                }

                document.getElementById('txn-amount').value = Number(fromTxn.amount).toLocaleString('en-US');
                if (fromTxn.currency !== (toTxn ? toTxn.currency : 'VND')) {
                    if (toTxn) {
                        const trAmt = document.getElementById('txn-transfer-amount');
                        if (trAmt) trAmt.value = Number(toTxn.amount).toLocaleString('en-US');
                    }
                }
                
                document.getElementById('txn-date').value = fromTxn.transaction_date;
                document.getElementById('txn-remark').value = fromTxn.remark || '';
                document.getElementById('currency-label').innerText = appState.formState.wallet.currency;

            } else {
                // Editing a Normal Transaction
                document.querySelector(`.type-btn[data-type="${txn.type}"]`).click();
                
                appState.formState.wallet = { id: txn.wallet_id, name: txn.wallets ? txn.wallets.name : 'Unknown', currency: txn.currency || 'VND' };
                appState.formState.category = { id: txn.category_id, name: txn.categories ? txn.categories.name : 'Uncategorized' };
                appState.formState.tag = { id: txn.tag_id, name: txn.tags ? txn.tags.name : 'Optional...' };

                document.getElementById('txn-amount').value = Number(txn.amount).toLocaleString('en-US');
                document.getElementById('txn-date').value = txn.transaction_date;
                document.getElementById('txn-remark').value = txn.remark || '';
                document.getElementById('currency-label').innerText = appState.formState.wallet.currency;
            }
            
            // Re-render display
            dispatchStateEvent('updateFormDisplay');

            document.getElementById('btn-save-txn').innerText = "Update Transaction";
        }, 50); 
    });

    // === TÍNH NĂNG COPY (NHÂN BẢN GIAO DỊCH) ===
    const btnCopy = document.getElementById('btn-detail-copy');
    if (btnCopy) {
        btnCopy.addEventListener('click', () => {
            if (!selectedTxnId) return;
            const txn = appState.currentTransactionsList.find(t => t.id === selectedTxnId);
            if (!txn) return;

            // 1. Đóng Detail Modal và Mở Form nhập liệu
            document.getElementById('btn-close-detail').click();
            document.getElementById('btn-fab').click();

            // QUAN TRỌNG: Không set appState.editingTxnId để ép nó là giao dịch TẠO MỚI
            appState.editingTxnId = null; 

            setTimeout(() => {
                if (txn.linked_txn_id) {
                    // Copy cho loại Transfer
                    document.querySelector(`.type-btn[data-type="transfer"]`).click();
                    const twin = appState.currentTransactionsList.find(x => x.id === txn.linked_txn_id);
                    let fromTxn, toTxn;
                    if (txn.type === 'expense') { fromTxn = txn; toTxn = twin; } 
                    else { fromTxn = twin; toTxn = txn; }

                    if (fromTxn && fromTxn.wallets) {
                        appState.formState.wallet = { id: fromTxn.wallet_id, name: fromTxn.wallets.name, currency: fromTxn.currency || 'VND' };
                    }
                    if (toTxn && toTxn.wallets) {
                        appState.formState.walletTo = { id: toTxn.wallet_id, name: toTxn.wallets.name, currency: toTxn.currency || 'VND' };
                    }

                    document.getElementById('txn-amount').value = Number(fromTxn.amount).toLocaleString('en-US');
                    if (fromTxn.currency !== (toTxn ? toTxn.currency : 'VND')) {
                        if (toTxn) {
                            const trAmt = document.getElementById('txn-transfer-amount');
                            if (trAmt) trAmt.value = Number(toTxn.amount).toLocaleString('en-US');
                        }
                    }
                    
                    document.getElementById('txn-remark').value = fromTxn.remark || '';
                    document.getElementById('currency-label').innerText = appState.formState.wallet.currency;

                } else {
                    // Copy cho giao dịch Normal (Income/Expense)
                    document.querySelector(`.type-btn[data-type="${txn.type}"]`).click();
                    
                    appState.formState.wallet = { id: txn.wallet_id, name: txn.wallets ? txn.wallets.name : 'Unknown', currency: txn.currency || 'VND' };
                    appState.formState.category = { id: txn.category_id, name: txn.categories ? txn.categories.name : 'Uncategorized' };
                    appState.formState.tag = { id: txn.tag_id, name: txn.tags ? txn.tags.name : 'Optional...' };

                    document.getElementById('txn-amount').value = Number(txn.amount).toLocaleString('en-US');
                    document.getElementById('txn-remark').value = txn.remark || '';
                    document.getElementById('currency-label').innerText = appState.formState.wallet.currency;
                }
                
                // Mặc định thiết lập Ngày cho giao dịch Copy là "Ngày hôm nay"
                document.getElementById('txn-date').value = new Date().toISOString().split('T')[0];
                
                // Cập nhật lại giao diện và Nút Save
                dispatchStateEvent('updateFormDisplay');
                document.getElementById('btn-save-txn').innerText = "Save Transaction";
                
                // Thêm một thông báo nhỏ để báo hiệu đã load xong dữ liệu copy
                showToast('Transaction data copied!', 'info');
            }, 50); 
        });
    }
}
